import { render, staticRenderFns } from "./edit-thumbnail-modal.vue?vue&type=template&id=6f145ff4&scoped=true&"
import script from "./edit-thumbnail-modal.vue?vue&type=script&lang=ts&"
export * from "./edit-thumbnail-modal.vue?vue&type=script&lang=ts&"
import style0 from "./edit-thumbnail-modal.vue?vue&type=style&index=0&id=6f145ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f145ff4",
  null
  
)

export default component.exports